import { useQuery } from 'react-query';
import { MaterialityAssessmentListResponse } from './materialityAssessmentTypes';
import { getMaterialityAssessmentList } from './materialityAssessmentService';

type Props<M> = {
    assessmentId: string;
    onError?: (error: Error) => void;
    onSuccess?: (data: MaterialityAssessmentListResponse) => void;
    mapper?: (
        data?: MaterialityAssessmentListResponse
    ) => M | MaterialityAssessmentListResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: MaterialityAssessmentListResponse) => data;

export const useGetMaterialityAssessmentList = <
    M = MaterialityAssessmentListResponse
>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
    assessmentId,
}: Props<M>) => {
    const query = useQuery<MaterialityAssessmentListResponse, Error>(
        ['materialityAssessments', assessmentId],
        () => getMaterialityAssessmentList(assessmentId),
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
